import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, Col, Row, Form, ModalFooter} from 'reactstrap'
import PropTypes from 'prop-types'
import {graphql, withApollo} from 'react-apollo'
import {CreateExportWelders} from './mutations'
import {GET_JOBS} from '../../JobsNotifications/graphql'
import {exportDefaultFormatKey} from '../../Profile/settings/SettingsForm'

const formats = [{name: 'Csv', value: 'csv'}, {name: 'Pdf', value: 'pdf'}]

class ExportWeldersModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      format: localStorage.getItem(exportDefaultFormatKey) || 'csv',
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    mutate: PropTypes.func.isRequired,
    toggleFunction: PropTypes.func.isRequired,
    show_certificates: PropTypes.bool.isRequired,
    show_approvals: PropTypes.bool.isRequired,
    merge_by_cert_no: PropTypes.bool.isRequired,
    filters: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.mutate({
      variables: {
        type: 'WlWelders::Jobs::ExportWelders',
        args: JSON.stringify({
          format: this.state.format,
          version: 'certificates',
          show_certificates: this.props.show_certificates,
          show_range_of_qualifications: this.props.show_approvals,
          merge_by_cert_no: this.props.merge_by_cert_no,
          filters: this.props.filters,
        })
      }
    }).then(() => {
      this.props.client.query({
        query: GET_JOBS,
        fetchPolicy: 'network-only'
      }).then(({ data }) => {
        const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
        const event = new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } })
        window.dispatchEvent(event)
      })
      this.props.toggleFunction()
    })
  }

  render() {
    return (
      <div>
        <Modal id="export-welders-modal" isOpen={true} className="modal-primary">
          <ModalHeader>Export</ModalHeader>
          <ModalBody>
            <Form>
              <Row>
                <Col md="12">
                  <h6>Choose export format:</h6>
                  <div className="raportBox">
                    {formats.map((format, i) => [
                      <input key={`ver_${i}`} type="radio" id={`format_${i}`} name="format" value={format.value}
                        onChange={(e) => this.setState({format: e.target.value})}
                        checked={this.state.format === format.value}
                      />,
                      <label key={i} htmlFor={`format_${i}`} name="version">{format.name}</label>
                    ]
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button id="generate-raport-btn" className="float-right" color="primary" type="submit" onClick={this.handleSubmit}>Export</Button>
            <Button id="cancel-report-btn" className="float-right" color="danger" onClick={this.props.toggleFunction}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const ExportWeldersWithMutation = graphql(CreateExportWelders)(ExportWeldersModal)

export default withApollo(ExportWeldersWithMutation)



// WEBPACK FOOTER //
// ./src/components/Welders/export_welders/ExportWeldersModal.js